import { createAction, props } from '@ngrx/store';
import {ManageUserPayload, CreateUserResponse} from '../../../services/api/users/user.model';

export const sendUserInvite = createAction(
  '[UserInvite] Send User Invite',
  props<{ data: ManageUserPayload }>()
)

export const sendUserInviteSuccess = createAction(
  '[UserInvite] Send User Invite Success',
  props<{ data: CreateUserResponse }>()
);

export const sendUserInviteFailure = createAction(
  '[UserInvite] Send User Invite Failure',
  props<{ error: unknown }>()
);

export const clearUserInviteState = createAction(
  '[UserInvite] Clear User Invite State',
);
